<template>
  <div>
    <MainTitle title="Repositorio" description="Repositorio de investigación científica nacional e internacional sobre el glifosato" />
    <div class="container">
      <div class="columns">
        <div class="column is-two-thirds m-b">
          <div id="repositorio">
            <img class="cover-repositorio" src="@/assets/img/repositorio-link.png" alt="">
            <a class="link-repositorio" 
              href="https://conahcyt.mx/cibiogem/index.php/sistema-nacional-de-informacion/documentos-y-actividades-en-bioseguridad/repositorio-glifosato#:~:text=La%20intenci%C3%B3n%20de%20generar%20este,enfoque%20del%20principio%20de%20precauci%C3%B3n" 
              target="_blank" rel="noopener">
              Ir a repositorio 
              <span class="icon">
                <span class="icono-md icono-atras" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainTitle from '@/components/MainTitle.vue'

export default {
  name: 'Repositorio',
  components: {
    MainTitle,
  },
}
</script>

<style scoped lang="scss">
#repositorio {
  margin-left: - #{$space};
  margin-right: - #{$space};
  @media (min-width: $breakpoint-tablet) {
    margin-left: 0;
    margin-right: 0;
  }
}
.cover-repositorio {
  width: 100%;
  object-fit: cover;
}
.link-repositorio {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background: $accion;
  border-radius: 0 $space $space 0;
  padding: 0 0 0 $space;
  position: relative;
  top: - ($space);
  margin-bottom:  - ($space);
  font-size: 20px;
  font-weight: 600;
  line-height: 1em;
  color: #fff;
  transition: background-color .27s ease-in-out;
  .icon {
    background: #fff;
    border-radius: 50%;
    display: inline-flex;
    height: $space * 1.8;
    width: $space * 1.8;
    margin: 2px 2px 2px $space;
    align-items: center;
    justify-content: center;
    transition: margin-left .27s ease-in-out;
    color: $accion;
    transform: rotate(180deg);
  }
  &:hover, &:focus {
    background: $accion-hover;
    .icon {
      margin-left: $space*2;
    }
  }
}
</style>